import type { TFunction } from 'i18next';

/** "45 s", "4 min 10 s", "12 min", "1 h 5 min". Seconds are dropped from 10 minutes on. */
export const formatSeconds = (total: number, t: TFunction): string => {
    const s = Math.max(0, Math.round(total));
    if (s < 60) return t('orderDetail:time.sec', { s });
    const m = Math.floor(s / 60);
    if (s < 600) return s % 60 === 0 ? t('orderDetail:time.min', { m }) : t('orderDetail:time.minSec', { m, s: s % 60 });
    if (m < 60) return t('orderDetail:time.min', { m });
    const h = Math.floor(m / 60);
    return m % 60 === 0 ? t('orderDetail:time.hour', { h }) : t('orderDetail:time.hourMin', { h, m: m % 60 });
};

/** Same, with "~" in front when the history was backfilled. */
export const formatApprox = (seconds: number, estimated: boolean, t: TFunction): string => {
    const text = formatSeconds(seconds, t);
    return estimated ? t('orderDetail:time.approx', { time: text }) : text;
};
